import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Link, useLocation, useNavigate, Navigate } from "react-router-dom";
import "@/App.css";
import Dashboard from "./pages/Dashboard";
import Landing from "./pages/Landing";
import AutomatedTradingJournal from "./pages/AutomatedTradingJournal";
import CryptoTradingJournal from "./pages/CryptoTradingJournal";
import HowToAnalyzeYourTrades from "./pages/HowToAnalyzeYourTrades";
import ManualVsAutomatedJournal from "./pages/ManualVsAutomatedJournal";
import WhyTradersFail from "./pages/WhyTradersFail";
import HowToFindTradingSetup from "./pages/HowToFindTradingSetup";
import ImproveRiskRewardRatio from "./pages/ImproveRiskRewardRatio";
import HowManyTradesToValidate from "./pages/HowManyTradesToValidate";
import HowToImproveDayTrading from "./pages/HowToImproveDayTrading";
import ProfitFactorTrading from "./pages/ProfitFactorTrading";
import WinRateTrading from "./pages/WinRateTrading";
import OvertradingExplained from "./pages/OvertradingExplained";
import WhyConsistencyIsHard from "./pages/WhyConsistencyIsHard";
import DiarioDeTradesAutomatico from "./pages/pt/DiarioDeTradesAutomatico";
import DiarioDeTradesCripto from "./pages/pt/DiarioDeTradesCripto";
import ComoAnalisarTrades from "./pages/pt/ComoAnalisarTrades";
import PorQueTradersNaoEvoluem from "./pages/pt/PorQueTradersNaoEvoluem";
import PorQueConsistenciaEDificil from "./pages/pt/PorQueConsistenciaEDificil";
import ComoMelhorarRiskReward from "./pages/pt/ComoMelhorarRiskReward";
import ProfitFactorTradingPT from "./pages/pt/ProfitFactorTradingPT";
import WinRateTradingPT from "./pages/pt/WinRateTradingPT";
import QuantosTradesValidar from "./pages/pt/QuantosTradesValidar";
import ComoEncontrarSetup from "./pages/pt/ComoEncontrarSetup";
import DiarioManualVsAutomatico from "./pages/pt/DiarioManualVsAutomatico";
import ComoMelhorarDayTrade from "./pages/pt/ComoMelhorarDayTrade";
import OvertradingPT from "./pages/pt/OvertradingPT";
import OQueEoGeni from "./pages/pt/OQueEoGeni";
import History from "./pages/History";
import Analytics from "./pages/Analytics";
import AdvancedAnalytics from "./pages/AdvancedAnalytics";
import Performance from "./pages/Performance";
import Holdings from "./pages/Holdings";
import ExchangeTrades from "./pages/ExchangeTrades";
import ImportExchangeData from "./pages/ImportExchangeData";
import OpenPositions from "./pages/OpenPositions";
import SetupTrades from "./pages/SetupTrades";
import TimeframeTrades from "./pages/TimeframeTrades";
import PlannedTradesDetail from "./pages/PlannedTradesDetail";
import PartialExecutionDetail from "./pages/PartialExecutionDetail";
import RiskViolationsDetail from "./pages/RiskViolationsDetail";
import EarlyExitsDetail from "./pages/EarlyExitsDetail";
import HedgeTradesDetail from "./pages/HedgeTradesDetail";
import HandSizeTradesDetail from "./pages/HandSizeTradesDetail";
import StopAdjustmentsDetail from "./pages/StopAdjustmentsDetail";
import Referral from "./pages/Referral";
import Billing from "./pages/Billing";
import Alerts from "./pages/Alerts";
import About from "./pages/About";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AuthConfirm from "./pages/AuthConfirm";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ShareView from "./pages/ShareView";
import SharedProfileGate from "./pages/SharedProfileGate";
import SharedPositionsPage from "./pages/SharedPositionsPage";
// Note: SharedProfile page clones removed - now using real components via SharedProfileWrapper
import Support from "./pages/Support";
import Admin from "./pages/Admin";
import DevAdminBootstrap from "./pages/DevAdminBootstrap";
import AllInsights from "./pages/AllInsights";
import ImportedAnalytics from "./pages/ImportedAnalytics";
import SetupGroupDetail from "./pages/SetupGroupDetail";
import AssetGroupDetail from "./pages/AssetGroupDetail";
import WhatIsGeni from "./pages/WhatIsGeni";
import Blog from "./pages/Blog";
import Settings from "./pages/Settings";
import OptionsHome from "./pages/options/OptionsHome";
import DeribitConnect from "./pages/options/DeribitConnect";
import Operations from "./pages/options/Operations";
import OptionsPositions from "./pages/options/OptionsPositions";
import OptionsAnalytics from "./pages/options/OptionsAnalytics";
import OptionsPerformance from "./pages/options/OptionsPerformance";
import OptionsHoldings from "./pages/options/OptionsHoldings";
import OptionsAlerts from "./pages/options/OptionsAlerts";
import OptionsAbout from "./pages/options/OptionsAbout";
import OptionsStart from "./pages/options/OptionsStart";
import BtcOutlook from "./pages/options/BtcOutlook";
import MarginVolatility from "./pages/options/MarginVolatility";
import OptionsVolatility from "./pages/options/OptionsVolatility";
import OptionsAutopilot from "./pages/options/OptionsAutopilot";
import OptionsGex from "./pages/options/OptionsGex";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import CryptoPaymentModal from "./components/CryptoPaymentModal";
import GuidedTour from "./components/GuidedTour";
import SharedProfileBanner from "./components/SharedProfileBanner";
import SharedProfileWrapper from "./components/SharedProfileWrapper";
import PublicProfileWrapper from "./components/PublicProfileWrapper";
import VanityUrlResolver from "./components/VanityUrlResolver";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SharedProfileProvider, useSharedProfile } from "./context/SharedProfileContext";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";
import { ClockCounterClockwise, ChartBar, Funnel, TrendUp, SignOut, Briefcase, CaretDown, CreditCard, Users, Headset, Flag, Bug, Lightbulb, X, CircleNotch, ShieldCheck, Clock, Bell, Crown, Info, MapTrifold, FileText, ShieldWarning, User, Star, Play, Eye, Globe, CaretRight, Check, Wallet, ArrowsClockwise, Plug, UploadSimple } from "phosphor-react";
import { LanguageProvider, useLanguage } from "./context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import api, { clearAdminViewMode, getAdminViewEmail, isInAdminViewMode } from "./lib/api";
import OptionsNavigation from "./components/options/OptionsNavigation";
import OptionsFeedbackWidget from "./components/options/OptionsFeedbackWidget";
import OptionsBetaAcknowledgeModal from "./components/options/OptionsBetaAcknowledgeModal";
import { OptionsProductUsageTracker } from "./components/options/OptionsProductUsageTracker";
import { OptionsModeProvider } from "./context/OptionsModeContext";
import { OptionsLanguageProvider } from "./context/OptionsLanguageContext";
import { resolvePostAuthDestination } from "./lib/productRouting";

// Horizontal logo for in-app navbar
const LOGO_HORIZONTAL = "https://customer-assets.emergentagent.com/job_chart-analyzer-107/artifacts/r9xkm2vj_cerebro%20%2B%20genilateral.png";

// Brain icon for Pro users
const PRO_BRAIN_ICON = "https://customer-assets.emergentagent.com/job_chart-analyzer-107/artifacts/9edc7349_justbrain.png";
const PLAN_DISPLAY_LABELS = { monthly: 'Monthly', yearly: 'Yearly', lifetime: 'Lifetime', beta: 'Beta' };
import UpgradeModal from "./components/UpgradeModal";
import GeniBetaProModal from "./components/GeniBetaProModal";
import TradesExchangeAnnouncementModal from "./components/TradesExchangeAnnouncementModal";
import { OptionsEntitlementsProvider } from "./context/OptionsEntitlementsContext";
import GeniLoader from "./components/GeniLoader";

// Home route component - shows Landing or redirects to the user's default product
const HomeRoute = () => {
  const { user, loading } = useAuth();
  const [destination, setDestination] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const resolveDestination = async () => {
      if (!user) {
        setDestination(null);
        return;
      }

      try {
        const nextDestination = await resolvePostAuthDestination({ requestedRedirect: '/dashboard' });
        if (isMounted) {
          setDestination(nextDestination);
        }
      } catch (error) {
        if (isMounted) {
          setDestination('/dashboard');
        }
      }
    };

    if (!loading) {
      resolveDestination();
    }

    return () => {
      isMounted = false;
    };
  }, [user, loading]);
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <GeniLoader size="md" />
      </div>
    );
  }
  
  if (user) {
    if (!destination) {
      return (
        <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
          <GeniLoader size="md" />
        </div>
      );
    }
    return <Navigate to={destination} replace />;
  }
  
  return <Landing />;
};

const AdminViewBanner = () => {
  const navigate = useNavigate();
  if (!isInAdminViewMode()) return null;
  return (
    <div className="flex items-center justify-center gap-3 bg-[#F59E0B]/15 border-b border-[#F59E0B]/25 px-4 py-2 text-sm text-[#F5C77E]" data-testid="admin-view-banner">
      <span data-testid="admin-view-banner-email">Visualizando: {getAdminViewEmail() || '—'}</span>
      <button
        type="button"
        className="rounded-full border border-[#F5C77E]/40 px-3 py-0.5 text-xs font-semibold text-[#F5C77E] hover:bg-[#F5C77E]/10"
        onClick={() => {
          clearAdminViewMode();
          navigate('/admin');
        }}
        data-testid="admin-view-exit-button"
      >
        Sair
      </button>
    </div>
  );
};

const OptionsRouteShell = ({ children }) => {
  const { user } = useAuth();
  const [showBetaProModal, setShowBetaProModal] = useState(false);

  const checkBetaEligibility = async () => {
    if (!user) return;
    try {
      const response = await api.get('/user/profile');
      const profile = response.data;
      if (profile.is_beta_pro_eligible === true) {
        setShowBetaProModal(true);
      }
    } catch (e) {
      console.error('Error checking beta eligibility:', e);
    }
  };

  useEffect(() => {
    checkBetaEligibility();
  }, [user]);

  return (
    <ProtectedRoute>
      <OptionsModeProvider>
        <OptionsLanguageProvider>
          <OptionsEntitlementsProvider>
            <div className="geni-options-typography min-h-screen bg-[#0A0A0A] text-white font-body" data-testid="options-route-shell-root">
              <AdminViewBanner />
              <OptionsBetaAcknowledgeModal />
              <OptionsProductUsageTracker />
              <OptionsNavigation />
              {children}
              <OptionsFeedbackWidget />
              <GeniBetaProModal
                isOpen={showBetaProModal}
                onClose={() => setShowBetaProModal(false)}
                onSuccess={checkBetaEligibility}
              />
            </div>
          </OptionsEntitlementsProvider>
        </OptionsLanguageProvider>
      </OptionsModeProvider>
    </ProtectedRoute>
  );
};

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut, user, isDemo, demoUser, enterDemoMode, exitDemoMode } = useAuth();
  const [openPositionsCount, setOpenPositionsCount] = useState(0);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportType, setReportType] = useState('');
  const [reportEmail, setReportEmail] = useState('');
  const [reportMessage, setReportMessage] = useState('');
  const [reportLoading, setReportLoading] = useState(false);
  const [reportSuccess, setReportSuccess] = useState(false);
  const [reportError, setReportError] = useState('');
  const [userRole, setUserRole] = useState(null); // null = loading, 'user' or 'admin'
  const [proStatus, setProStatus] = useState({ isPro: false, plan: null, expiresAt: null, isDemo: false });
  const [proStatusLoading, setProStatusLoading] = useState(true); // Track if subscription status is loading
  const [pendingUpgrade, setPendingUpgrade] = useState({ isPending: false, plan: null });
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showBetaProModal, setShowBetaProModal] = useState(false);
  window.showBetaProModalState = showBetaProModal;
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [upgradeModalMode, setUpgradeModalMode] = useState(null); // null = full, 'yearly-only' = yearly only
  const [isUpgradeFlow, setIsUpgradeFlow] = useState(false); // true when Monthly user upgrades to Yearly
  const [upgradePrice, setUpgradePrice] = useState(null); // discounted price for upgrades
  const [showTour, setShowTour] = useState(false);
  const [demoLoading, setDemoLoading] = useState(false); // Loading state for demo switch
  const [showLanguageMenu, setShowLanguageMenu] = useState(false); // Language submenu
  const menuRef = useRef(null);
  const reportModalRef = useRef(null);
  const tourAutoLaunchedRef = useRef(false); // Guard against repeated auto-launches
  const { t, language, setLanguage, currentLanguage, languages } = useLanguage();
  
  // Check if tour should auto-start on first visit (user-specific)
  useEffect(() => {
    // Only run once per mount, when user is loaded, on dashboard, and not already completed
    if (
      user?.id && 
      location.pathname === '/dashboard' && 
      !tourAutoLaunchedRef.current
    ) {
      const tourKey = `geni_tour_completed_${user.id}`;
      const isCompleted = localStorage.getItem(tourKey) === 'true';
      
      // Debug logging (can be removed later)
      console.log('[Tour Debug] User ID:', user.id);
      console.log('[Tour Debug] Tour Key:', tourKey);
      console.log('[Tour Debug] Is Completed:', isCompleted);
      
      if (!isCompleted) {
        console.log('[Tour Debug] Auto-starting tour for first-time user');
        tourAutoLaunchedRef.current = true; // Prevent re-triggering
        const timer = setTimeout(() => setShowTour(true), 500);
        return () => clearTimeout(timer);
      } else {
        console.log('[Tour Debug] Tour already completed, not auto-showing');
      }
    }
  }, [user?.id, location.pathname]); // Use user.id specifically, not entire user object
  
  // Refetch profile when demo mode changes
  useEffect(() => {
    if (user) {
      fetchUserProfile();
    }
  }, [isDemo]);
  
  // Fetch user profile (role + subscription)
  const fetchUserProfile = async () => {
    if (!user) {
      setProStatusLoading(false);
      return;
    }
    setProStatusLoading(true);
    try {
      const response = await api.get('/user/profile');
      const profile = response.data;
      console.log('fetchUserProfile profile loaded:', profile);
      
      
      // Set role
      setUserRole(profile.role || 'user');
      
      // Check dynamic Beta PRO eligibility
      console.log('is_beta_pro_eligible status:', profile.is_beta_pro_eligible);
      window.isBetaProEligibleProfile = profile.is_beta_pro_eligible;
      if (profile.is_beta_pro_eligible === true) {
        console.log('Setting showBetaProModal to true');
        setShowBetaProModal(true);
      }
      
      // Demo accounts always have PRO status
      const isDemoAccount = profile.is_demo === true;
      const isLifetimePlan = profile.subscription_plan === 'lifetime';
      const hasActiveProProfile = profile.subscription_status === 'pro' && (isLifetimePlan || profile.subscription_expires_at);
      
      // Check Pro status with full details
      if (isDemoAccount || hasActiveProProfile) {
        const expiresAt = profile.subscription_expires_at
          ? new Date(profile.subscription_expires_at)
          : isDemoAccount
            ? new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)
            : null;
        const isActive = isDemoAccount || isLifetimePlan || (expiresAt && expiresAt > new Date());
        setProStatus({
          isPro: isActive,
          plan: profile.subscription_plan || 'yearly',
          expiresAt: isActive ? expiresAt : null,
          isDemo: isDemoAccount
        });
      } else {
        setProStatus({ isPro: false, plan: null, expiresAt: null, isDemo: false });
      }
    } catch (error) {
      console.error('Error fetching user profile:', error);
      // Conservar o estado anterior e não anular nem definir como FREE em falhas temporárias de conexão/autorização
      setUserRole('user');
    } finally {
      setProStatusLoading(false);
    }
  };

  // Check for pending payment
  const checkPendingPayment = async () => {
    if (!user) return;
    try {
      const response = await api.get('/payments/my');
      const payments = response.data;
      
      // Find pending payment
      const pendingPayment = payments.find(p => p.status === 'pending');
      if (pendingPayment) {
        setPendingUpgrade({
          isPending: true,
          plan: pendingPayment.plan_type
        });
      } else {
        setPendingUpgrade({ isPending: false, plan: null });
      }
    } catch (error) {
      console.error('Error checking pending payment:', error);
      setPendingUpgrade({ isPending: false, plan: null });
    }
  };

  useEffect(() => {
    fetchUserProfile();
    checkPendingPayment();
  }, [user]);

  // Handle plan selection from upgrade modal
  const handleSelectPlan = (plan, isUpgrade = false, upgradePrice = null) => {
    setSelectedPlan(plan);
    setShowUpgradeModal(false);
    setUpgradeModalMode(null); // Reset mode
    
    // Pass upgrade context to payment modal
    if (isUpgrade) {
      setIsUpgradeFlow(true);
      setUpgradePrice(upgradePrice || 79);
    } else {
      setIsUpgradeFlow(false);
      setUpgradePrice(null);
    }
    
    setShowPaymentModal(true);
  };

  // Open upgrade modal in yearly-only mode with upgrade context (for Pro Monthly users)
  const openYearlyUpgradeModal = (asUpgrade = false) => {
    setUpgradeModalMode('yearly-only');
    setIsUpgradeFlow(asUpgrade);
    setUpgradePrice(asUpgrade ? 79 : null);
    setShowUpgradeModal(true);
  };
  
  // 2-step upgrade flow for Monthly -> Yearly (opens info modal first)
  const handleUpgradeToYearly = () => {
    setShowUserMenu(false); // Close the user menu
    openYearlyUpgradeModal(true); // Open upgrade modal with upgrade context
  };
  
  // Format expiration date
  const formatExpirationDate = (date) => {
    if (!date) return '';
    return new Intl.DateTimeFormat('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    }).format(date);
  };
  
  // Determine which indicator to show (Pro takes priority)
  const showProIndicator = proStatus.isPro;
  const showPendingIndicator = !proStatus.isPro && pendingUpgrade.isPending;
  
  // Get Pro tooltip text
  const getProTooltip = () => {
    if (!proStatus.isPro) return '';
    const planLabel = PLAN_DISPLAY_LABELS[proStatus.plan] || 'Monthly';
    return `Pro · ${planLabel}`;
  };
  
  // Get username from email (part before @)
  const getUsername = () => {
    if (!user?.email) return 'User';
    return user.email.split('@')[0];
  };
  
  // Centralized helper to close the user menu
  const closeUserMenu = () => {
    setShowUserMenu(false);
    setShowLanguageMenu(false);
  };
  
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeUserMenu();
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  
  useEffect(() => {
    const fetchOpenCount = async () => {
      try {
        const response = await api.get('/trades/open');
        setOpenPositionsCount(response.data.count || 0);
      } catch (error) {
        // Silently fail - user might not be authenticated yet
      }
    };
    
    if (user) {
      fetchOpenCount();
      // Refresh every 30 seconds
      const interval = setInterval(fetchOpenCount, 30000);
      return () => clearInterval(interval);
    }
  }, [user]);
  
  const handleLogout = async () => {
    try {
      // Exit demo mode if active before logout
      if (isDemo) {
        exitDemoMode();
      }
      await signOut();
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  // Handle demo mode switch
  const handleDemoSwitch = async () => {
    if (isDemo) {
      // Exit demo mode
      exitDemoMode();
      toast.success('Exited demo mode');
      navigate('/dashboard');
    } else {
      // Enter demo mode
      setDemoLoading(true);
      closeUserMenu();
      const result = await enterDemoMode();
      setDemoLoading(false);
      
      if (result.success) {
        toast.success('Welcome to the Demo Account!');
        navigate('/dashboard');
      } else {
        toast.error(result.error || 'Failed to load demo account');
      }
    }
  };

  const handleMenuAction = (action) => {
    closeUserMenu();
    if (action === 'Support') {
      navigate('/support');
    } else if (action === 'Report') {
      setReportEmail(user?.email || '');
      setShowReportModal(true);
    } else if (action === 'Referral') {
      navigate('/referral');
    } else if (action === 'Billing') {
      navigate('/billing');
    } else if (action === 'Settings') {
      navigate('/settings');
    } else {
      toast.info(`${action} coming soon`);
      console.log(`Menu action: ${action}`);
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleReportSubmit = async (e) => {
    e.preventDefault();
    setReportError('');

    if (!reportType) {
      setReportError('Please select a report type');
      return;
    }
    if (!reportEmail || !validateEmail(reportEmail)) {
      setReportError('Please enter a valid email address');
      return;
    }
    if (!reportMessage || reportMessage.trim().length === 0) {
      setReportError('Please enter your message');
      return;
    }

    setReportLoading(true);

    try {
      await api.post('/report', {
        type: reportType,
        email: reportEmail.trim(),
        message: reportMessage.trim()
      });

      setReportSuccess(true);
      toast.success('Your report has been sent successfully');
    } catch (err) {
      console.error('Report error:', err);
      setReportError('Failed to send report. Please try again.');
      toast.error('Failed to send report');
    } finally {
      setReportLoading(false);
    }
  };

  const closeReportModal = () => {
    setShowReportModal(false);
    setReportType('');
    setReportEmail('');
    setReportMessage('');
    setReportError('');
    setReportSuccess(false);
  };
  
  return (
    <>
      {/* Demo Mode Banner */}
      {isDemo && (
        <div className="bg-gradient-to-r from-purple-600/90 to-violet-600/90 text-white text-center py-2 px-4 text-sm font-medium flex items-center justify-center gap-3">
          <Eye size={16} weight="fill" />
          <span>{t('menu.viewingDemo')}</span>
          <span className="text-white/50">|</span>
          <span className="text-white/70 text-xs">{language === 'ptBR' ? 'Dados de trading simulados mas realistas' : 'Simulated but realistic trading data'}</span>
          <button 
            onClick={handleDemoSwitch}
            className="ml-4 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-sm text-xs font-bold transition-colors"
          >
            {t('menu.exitDemo').split(' ')[0]}
          </button>
        </div>
      )}
      <nav className="border-b border-white/10 bg-[#0A0A0A]" data-testid="main-navigation">
      <div className="w-full max-w-[1600px] mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo - Horizontal Version */}
          <div className="flex items-center flex-shrink-0 leading-none">
            <img
              src={LOGO_HORIZONTAL}
              alt="GENI"
              className="h-10 md:h-11 lg:h-12 w-auto object-contain"
              data-testid="app-logo"
            />
          </div>
          
          <div className="flex gap-1 items-center">
            <Link
              to="/dashboard"
              data-testid="nav-dashboard"
              className={`px-4 py-2 text-sm font-semibold transition-colors rounded-sm ${
                location.pathname === "/dashboard"
                  ? "bg-white text-black"
                  : "text-white/60 hover:text-white hover:bg-white/5"
              }`}
            >
              {t('nav.dashboard')}
            </Link>
            <Link
              to="/positions"
              data-testid="nav-open-positions"
              className={`px-4 py-2 text-sm font-semibold transition-colors rounded-sm flex items-center gap-2 ${
                location.pathname === "/positions"
                  ? "bg-white text-black"
                  : "text-white/60 hover:text-white hover:bg-white/5"
              }`}
            >
              <Briefcase size={16} weight="duotone" />
              {t('nav.openPositions')}
              {openPositionsCount > 0 && (
                <span className={`px-1.5 py-0.5 text-xs font-bold rounded ${
                  location.pathname === "/positions"
                    ? "bg-black text-white"
                    : "bg-[#00E676] text-black"
                }`}>
                  {openPositionsCount}
                </span>
              )}
            </Link>
            <Link
              to="/history"
              data-testid="nav-history"
              className={`px-4 py-2 text-sm font-semibold transition-colors rounded-sm flex items-center gap-2 ${
                location.pathname === "/history"
                  ? "bg-white text-black"
                  : "text-white/60 hover:text-white hover:bg-white/5"
              }`}
            >
              <ClockCounterClockwise size={16} weight="duotone" />
              {t('nav.history')}
            </Link>
            <Link
              to="/analytics"
              data-testid="nav-analytics"
              className={`px-4 py-2 text-sm font-semibold transition-colors rounded-sm flex items-center gap-2 ${
                location.pathname === "/analytics"
                  ? "bg-white text-black"
                  : "text-white/60 hover:text-white hover:bg-white/5"
              }`}
            >
              <ChartBar size={16} weight="duotone" />
              {t('nav.analytics')}
            </Link>
            <Link
              to="/advanced"
              data-testid="nav-advanced"
              className={`px-4 py-2 text-sm font-semibold transition-colors rounded-sm flex items-center gap-2 ${
                location.pathname === "/advanced"
                  ? "bg-white text-black"
                  : "text-white/60 hover:text-white hover:bg-white/5"
              }`}
            >
              <Funnel size={16} weight="duotone" />
              {t('nav.advanced')}
            </Link>
            <Link
              to="/performance"
              data-testid="nav-performance"
              className={`px-4 py-2 text-sm font-semibold transition-colors rounded-sm flex items-center gap-2 ${
                location.pathname === "/performance"
                  ? "bg-white text-black"
                  : "text-white/60 hover:text-white hover:bg-white/5"
              }`}
            >
              <TrendUp size={16} weight="duotone" />
              {t('nav.performance')}
            </Link>
            <Link
              to="/exchange-trades"
              data-testid="nav-exchange-trades"
              className={`px-4 py-2 text-sm font-semibold transition-colors rounded-sm flex items-center gap-2 ${
                location.pathname === "/exchange-trades"
                  ? "bg-white text-black"
                  : "text-white/60 hover:text-white hover:bg-white/5"
              }`}
            >
              <Plug size={16} weight="duotone" />
              Pending Trades
            </Link>
            <Link
              to="/holdings"
              data-testid="nav-holdings"
              className={`px-4 py-2 text-sm font-semibold transition-colors rounded-sm flex items-center gap-2 ${
                location.pathname === "/holdings"
                  ? "bg-white text-black"
                  : "text-white/60 hover:text-white hover:bg-white/5"
              }`}
            >
              <Wallet size={16} weight="duotone" />
              Holdings
            </Link>
            <Link
              to="/alerts"
              data-testid="nav-alerts"
              className={`px-4 py-2 text-sm font-semibold transition-colors rounded-sm flex items-center gap-2 ${
                location.pathname === "/alerts"
                  ? "bg-white text-black"
                  : "text-white/60 hover:text-white hover:bg-white/5"
              }`}
            >
              <Bell size={16} weight="duotone" />
              {t('nav.alerts')}
            </Link>
            <Link
              to="/about"
              data-testid="nav-about"
              className={`px-4 py-2 text-sm font-semibold transition-colors rounded-sm flex items-center gap-2 ${
                location.pathname === "/about"
                  ? "bg-white text-black"
                  : "text-white/60 hover:text-white hover:bg-white/5"
              }`}
            >
              <Info size={16} weight="duotone" />
              {t('nav.about')}
            </Link>
            
            <div className="ml-4 pl-4 border-l border-white/10 flex items-center gap-3">
              {/* User Menu Dropdown */}
              <div className="relative" ref={menuRef}>
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  data-testid="user-menu-trigger"
                  className="flex items-center gap-1.5 px-2 py-1.5 rounded-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                >
                  {/* Show placeholder while loading, then brain/avatar based on status */}
                  {proStatusLoading ? (
                    <div className="h-5 md:h-6 w-5 md:w-6 rounded-full bg-white/10 animate-pulse" />
                  ) : proStatus.isPro ? (
                    <img
                      src={PRO_BRAIN_ICON}
                      alt="Pro User"
                      className="h-5 md:h-6 w-auto object-contain opacity-90 hover:opacity-100 transition"
                      data-testid="pro-brain-indicator"
                    />
                  ) : (
                    <User size={22} weight="fill" className="text-white/80" />
                  )}
                  <CaretDown 
                    size={14} 
                    weight="bold" 
                    className={`transition-transform ${showUserMenu ? 'rotate-180' : ''}`} 
                  />
                </button>
                
                {/* Dropdown Menu */}
                {showUserMenu && (
                  <div 
                    className="absolute right-0 top-full mt-1 w-56 bg-[#121212] border border-white/10 rounded-sm shadow-xl z-50"
                    data-testid="user-menu-dropdown"
                  >
                    <div className="p-3 border-b border-white/10">
                      <div className="text-xs text-white/40 mb-1">Signed in as</div>
                      <div className="text-sm text-white/80 truncate" title={user?.email}>
                        {user?.email}
                      </div>
                      {/* Pro status section */}
                      {showProIndicator && (
                        <div className="mt-3 pt-3 border-t border-white/5">
                          <div className="flex items-center justify-between text-xs">
                            <span className="text-white/40">Plan</span>
                            <span className="text-[#F0B90B] font-medium flex items-center gap-1">
                              <span>✦</span>
                              Pro {PLAN_DISPLAY_LABELS[proStatus.plan] || 'Monthly'}
                            </span>
                          </div>
                        </div>
                      )}
                      {/* Pending upgrade section */}
                      {showPendingIndicator && (
                        <div className="mt-3 pt-3 border-t border-white/5">
                          <div className="flex items-center justify-between text-xs">
                            <span className="text-white/40">Status</span>
                            <span className="text-[#B8956A] font-medium flex items-center gap-1">
                              <Clock size={10} weight="fill" />
                              Pending Upgrade
                            </span>
                          </div>
                          {pendingUpgrade.plan && (
                            <div className="flex items-center justify-between text-xs mt-1.5">
                              <span className="text-white/40">Plan</span>
                              <span className="text-white/60">
                                Pro {PLAN_DISPLAY_LABELS[pendingUpgrade.plan] || 'Monthly'}
                              </span>
                            </div>
                          )}
                          <div className="mt-2 text-xs text-white/40">
                            Your payment is under review
                          </div>
                        </div>
                      )}
                    </div>
                    
                    {/* Become Pro - Only for free users without pending payment */}
                    {!proStatus.isPro && !pendingUpgrade.isPending && (
                      <div className="py-1 border-b border-[#F0B90B]/20 bg-[#F0B90B]/5">
                        <button
                          onClick={() => {
                            closeUserMenu();
                            setUpgradeModalMode(null);
                            setShowUpgradeModal(true);
                          }}
                          data-testid="menu-become-pro"
                          className="w-full flex items-center gap-3 px-4 py-2 text-sm text-[#F0B90B] hover:text-[#F0B90B] hover:bg-[#F0B90B]/10 transition-colors font-semibold"
                        >
                          <Crown size={18} weight="fill" />
                          {t('menu.becomePro')}
                        </button>
                      </div>
                    )}

                    {/* Upgrade to Yearly - Only for Pro Monthly users */}
                    {proStatus.isPro && proStatus.plan === 'monthly' && !pendingUpgrade.isPending && (
                      <div className="py-1 border-b border-[#FFD700]/20 bg-gradient-to-r from-[#FFD700]/5 to-[#FFA500]/5">
                        <button
                          onClick={() => {
                            handleUpgradeToYearly();
                          }}
                          data-testid="menu-upgrade-yearly"
                          className="w-full flex items-center justify-between px-4 py-2 text-sm hover:bg-[#FFD700]/10 transition-colors"
                        >
                          <span className="flex items-center gap-3 text-[#FFD700] font-semibold">
                            <Star size={18} weight="fill" />
                            Upgrade to Yearly
                          </span>
                          <span className="text-[10px] bg-[#00E676] text-black font-bold px-1.5 py-0.5 rounded-sm">
                            SAVE 40%
                          </span>
                        </button>
                      </div>
                    )}

                    {/* Demo Account - Purple styled button - Only for non-Pro users */}
                    {!proStatus.isPro && (
                      <div className="py-1 border-b border-purple-500/20 bg-gradient-to-r from-purple-500/5 to-violet-500/5">
                        <button
                          onClick={handleDemoSwitch}
                          disabled={demoLoading}
                          data-testid="menu-demo-account"
                          className="w-full flex items-center justify-between px-4 py-2 text-sm hover:bg-purple-500/10 transition-colors"
                        >
                          <span className="flex items-center gap-3 text-purple-400 font-semibold">
                            {demoLoading ? (
                              <CircleNotch size={18} weight="bold" className="animate-spin" />
                            ) : isDemo ? (
                              <Eye size={18} weight="fill" />
                            ) : (
                              <Play size={18} weight="fill" />
                            )}
                            {isDemo ? t('menu.exitDemo') : t('menu.demoAccount')}
                          </span>
                          {!isDemo && (
                            <span className="text-[10px] bg-purple-500 text-white font-bold px-1.5 py-0.5 rounded-sm">
                              {t('menu.tryLabel')}
                            </span>
                          )}
                        </button>
                      </div>
                    )}
                    
                    {/* Admin Panel - Only visible to actual admins */}
                    {userRole === 'admin' && (
                      <div className="py-1 border-b border-purple-500/20 bg-purple-500/5">
                        <button
                          onClick={() => {
                            closeUserMenu();
                            navigate('/admin');
                          }}
                          data-testid="menu-admin"
                          className="w-full flex items-center gap-3 px-4 py-2 text-sm text-purple-400 hover:text-purple-300 hover:bg-purple-500/10 transition-colors font-semibold"
                        >
                          <ShieldCheck size={18} weight="fill" />
                          {t('nav.admin')}
                        </button>
                      </div>
                    )}
                    
                    <div className="py-1">
                      <button
                        onClick={() => handleMenuAction('Billing')}
                        data-testid="menu-billing"
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                      >
                        <CreditCard size={16} weight="duotone" />
                        {t('menu.billing')}
                      </button>
                      <button
                        onClick={() => handleMenuAction('Referral')}
                        data-testid="menu-referral"
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                      >
                        <Users size={16} weight="duotone" />
                        {t('menu.referral')}
                      </button>
                      <button
                        onClick={() => {
                          closeUserMenu();
                          navigate('/options');
                        }}
                        data-testid="menu-options"
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                      >
                        <Briefcase size={16} weight="duotone" />
                        GENI Options
                      </button>
                      <button
                        onClick={() => {
                          closeUserMenu();
                          navigate('/exchange-trades/connect');
                        }}
                        data-testid="menu-api-connections"
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                      >
                        <Plug size={16} weight="duotone" />
                        API
                      </button>
                      <button
                        onClick={() => {
                          closeUserMenu();
                          navigate('/exchange-import');
                        }}
                        data-testid="menu-import-exchange-data"
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                      >
                        <UploadSimple size={16} weight="duotone" />
                        Import Exchange Data
                      </button>
                      <button
                        onClick={() => handleMenuAction('Settings')}
                        data-testid="menu-settings"
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                      >
                        <Clock size={16} weight="duotone" />
                        {t('menu.settings')}
                      </button>
                      <button
                        onClick={() => {
                          closeUserMenu();
                          // Navigate to dashboard first if not there
                          if (location.pathname !== '/dashboard') {
                            navigate('/dashboard');
                          }
                          // Small delay to ensure we're on dashboard
                          setTimeout(() => setShowTour(true), 100);
                        }}
                        data-testid="menu-take-tour"
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                      >
                        <MapTrifold size={16} weight="duotone" />
                        {t('menu.takeTour')}
                      </button>
                      <Link
                        to="/terms"
                        onClick={closeUserMenu}
                        data-testid="menu-terms"
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                      >
                        <FileText size={16} weight="duotone" />
                        {t('menu.termsOfUse')}
                      </Link>
                      <Link
                        to="/privacy"
                        onClick={closeUserMenu}
                        data-testid="menu-privacy"
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                      >
                        <ShieldWarning size={16} weight="duotone" />
                        {t('menu.privacyPolicy')}
                      </Link>
                      <button
                        onClick={() => handleMenuAction('Support')}
                        data-testid="menu-support"
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                      >
                        <Headset size={16} weight="duotone" />
                        {t('menu.support')}
                      </button>
                      <button
                        onClick={() => handleMenuAction('Report')}
                        data-testid="menu-report"
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                      >
                        <Flag size={16} weight="duotone" />
                        {t('menu.report')}
                      </button>
                    </div>
                    
                    {/* Language Selector */}
                    <div className="border-t border-white/10 py-1">
                      <div className="relative">
                        <button
                          onClick={() => setShowLanguageMenu(!showLanguageMenu)}
                          data-testid="menu-language"
                          className="w-full flex items-center justify-between px-4 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                        >
                          <span className="flex items-center gap-3">
                            <Globe size={16} weight="duotone" />
                            {t('menu.language')} ({currentLanguage.shortName})
                          </span>
                          <CaretRight size={14} className={`transition-transform ${showLanguageMenu ? 'rotate-90' : ''}`} />
                        </button>
                        
                        {showLanguageMenu && (
                          <div className="border-t border-white/5 bg-black/20">
                            {languages.map((lang) => (
                              <button
                                key={lang.code}
                                onClick={() => {
                                  if (lang.available) {
                                    setLanguage(lang.code);
                                    setShowLanguageMenu(false);
                                  } else {
                                    // Show toast for unavailable languages
                                    toast.info(language === 'ptBR' ? 'Idioma ainda não disponível' : 'Language not available yet', {
                                      duration: 2000,
                                    });
                                  }
                                }}
                                data-testid={`language-${lang.code}`}
                                className={`w-full flex items-center justify-between px-4 py-2 text-sm transition-colors ${
                                  language === lang.code 
                                    ? 'text-[#00E676] bg-[#00E676]/5' 
                                    : 'text-white/60 hover:text-white hover:bg-white/5'
                                }`}
                              >
                                <span className="pl-7">{lang.name}</span>
                                {language === lang.code && <Check size={14} weight="bold" />}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    
                    <div className="border-t border-white/10 py-1">
                      <button
                        onClick={() => {
                          closeUserMenu();
                          handleLogout();
                        }}
                        data-testid="menu-logout"
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-[#FF3B30]/80 hover:text-[#FF3B30] hover:bg-[#FF3B30]/10 transition-colors"
                      >
                        <SignOut size={16} weight="duotone" />
                        {t('menu.logout')}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Upgrade Modal - Plan Selection */}
      <UpgradeModal
        isOpen={showUpgradeModal}
        onClose={() => {
          setShowUpgradeModal(false);
          setUpgradeModalMode(null);
          setIsUpgradeFlow(false);
          setUpgradePrice(null);
        }}
        onSelectPlan={handleSelectPlan}
        hasPendingPayment={pendingUpgrade.isPending}
        mode={upgradeModalMode}
        isUpgrade={isUpgradeFlow}
        upgradePrice={upgradePrice || 79}
        userEmail={user?.email}
      />

      {/* Beta PRO 60 Days Modal */}
      <GeniBetaProModal
        isOpen={showBetaProModal}
        onClose={() => setShowBetaProModal(false)}
        onSuccess={fetchUserProfile}
      />

      {/* Payment Modal - After Plan Selection */}
      <CryptoPaymentModal
        isOpen={showPaymentModal}
        onClose={() => {
          setShowPaymentModal(false);
          setIsUpgradeFlow(false);
          setUpgradePrice(null);
        }}
        onPaymentSubmitted={() => {
          setShowPaymentModal(false);
          setIsUpgradeFlow(false);
          setUpgradePrice(null);
          toast.success("Payment submitted! Your upgrade is being processed.");
          // Refresh the pending status
          checkPendingPayment();
        }}
        initialPlan={selectedPlan}
        isUpgrade={isUpgradeFlow}
        upgradePrice={upgradePrice}
        onBack={() => {
          setShowPaymentModal(false);
          setShowUpgradeModal(true);
        }}
      />

      {/* Report Modal */}
      {showReportModal && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80"
          onClick={(e) => {
            if (e.target === e.currentTarget) closeReportModal();
          }}
          data-testid="report-modal-overlay"
        >
          <div 
            ref={reportModalRef}
            className="bg-[#121212] border border-white/10 rounded-sm p-6 w-full max-w-md mx-4 relative"
            data-testid="report-modal"
          >
            {/* Close button */}
            <button
              onClick={closeReportModal}
              className="absolute top-4 right-4 text-white/40 hover:text-white transition-colors"
              data-testid="report-modal-close"
            >
              <X size={20} weight="bold" />
            </button>

            <h3 className="text-xl font-bold font-heading mb-4 flex items-center gap-2">
              <Flag size={24} weight="duotone" className="text-white/60" />
              {reportSuccess ? 'Report Sent!' : 'Send a Report'}
            </h3>

            {reportSuccess ? (
              <div className="text-center py-4">
                <div className="w-16 h-16 bg-[#00E676]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-[#00E676]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-white/60 mb-6">
                  Your report has been sent successfully. Thank you for your feedback!
                </p>
                <Button
                  onClick={closeReportModal}
                  className="bg-white text-black font-bold hover:bg-gray-200"
                  data-testid="report-close-btn"
                >
                  Close
                </Button>
              </div>
            ) : (
              <form onSubmit={handleReportSubmit} className="space-y-4">
                {/* Type Selector */}
                <div>
                  <Label className="text-white/80 mb-2 block">
                    Report Type <span className="text-[#FF3B30]">*</span>
                  </Label>
                  <div className="grid grid-cols-2 gap-2">
                    <button
                      type="button"
                      onClick={() => setReportType('bug')}
                      className={`p-3 rounded-sm border flex flex-col items-center gap-2 transition-colors ${
                        reportType === 'bug'
                          ? 'bg-[#FF3B30]/10 border-[#FF3B30]/50 text-white'
                          : 'bg-[#0A0A0A] border-white/10 text-white/60 hover:border-white/20'
                      }`}
                      data-testid="report-type-bug"
                    >
                      <Bug size={24} weight="duotone" className={reportType === 'bug' ? 'text-[#FF3B30]' : ''} />
                      <span className="text-sm font-medium">Report Bug</span>
                    </button>
                    <button
                      type="button"
                      onClick={() => setReportType('feature')}
                      className={`p-3 rounded-sm border flex flex-col items-center gap-2 transition-colors ${
                        reportType === 'feature'
                          ? 'bg-[#00E676]/10 border-[#00E676]/50 text-white'
                          : 'bg-[#0A0A0A] border-white/10 text-white/60 hover:border-white/20'
                      }`}
                      data-testid="report-type-feature"
                    >
                      <Lightbulb size={24} weight="duotone" className={reportType === 'feature' ? 'text-[#00E676]' : ''} />
                      <span className="text-sm font-medium">Ask for Feature</span>
                    </button>
                  </div>
                </div>

                {/* Email */}
                <div>
                  <Label htmlFor="report-email" className="text-white/80 mb-2 block">
                    Your Email <span className="text-[#FF3B30]">*</span>
                  </Label>
                  <Input
                    id="report-email"
                    type="email"
                    value={reportEmail}
                    onChange={(e) => setReportEmail(e.target.value)}
                    placeholder="your@email.com"
                    required
                    disabled={reportLoading}
                    className="bg-[#0A0A0A] border-white/10 text-white"
                    data-testid="report-email"
                  />
                </div>

                {/* Message */}
                <div>
                  <Label htmlFor="report-message" className="text-white/80 mb-2 block">
                    Message <span className="text-[#FF3B30]">*</span>
                  </Label>
                  <Textarea
                    id="report-message"
                    value={reportMessage}
                    onChange={(e) => setReportMessage(e.target.value)}
                    placeholder={reportType === 'bug' ? 'Describe the bug you encountered...' : 'Describe the feature you would like...'}
                    required
                    disabled={reportLoading}
                    rows={4}
                    className="bg-[#0A0A0A] border-white/10 text-white resize-none"
                    data-testid="report-message"
                  />
                </div>

                {/* Error */}
                {reportError && (
                  <div className="bg-[#FF3B30]/10 border border-[#FF3B30]/30 rounded-sm p-3" data-testid="report-error">
                    <p className="text-[#FF3B30] text-sm">{reportError}</p>
                  </div>
                )}

                {/* Buttons */}
                <div className="flex gap-2 pt-2">
                  <Button
                    type="button"
                    onClick={closeReportModal}
                    variant="outline"
                    className="flex-1 border-white/10 text-white hover:bg-white/5"
                    disabled={reportLoading}
                    data-testid="report-cancel"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    disabled={reportLoading}
                    className="flex-1 bg-white text-black font-bold hover:bg-gray-200 disabled:opacity-50"
                    data-testid="report-submit"
                  >
                    {reportLoading ? (
                      <span className="flex items-center justify-center gap-2">
                        <CircleNotch size={18} className="animate-spin" />
                        Sending...
                      </span>
                    ) : (
                      'Send'
                    )}
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {/* Guided Tour */}
      <GuidedTour 
        isOpen={showTour} 
        onClose={() => setShowTour(false)}
        userId={user?.id}
      />
    </nav>
    </>
  );
};

function AppContent() {
  const { isSharedProfileView, isPublicProfileView, exitPublicProfileMode, exitSharedMode } = useSharedProfile();
  const location = useLocation();
  
  // Clear public profile mode when navigating away from public profile routes
  useEffect(() => {
    const isPublicProfileRoute = location.pathname.startsWith('/profile/') || location.pathname.startsWith('/u/');
    const isSharedProfileRoute = location.pathname.startsWith('/shared/') || location.pathname.startsWith('/share/');
    
    // If we're in public profile mode but navigated away from public profile routes, exit
    if (isPublicProfileView && !isPublicProfileRoute) {
      exitPublicProfileMode();
    }
    
    // If we're in shared profile mode but navigated away from shared routes, exit
    if (isSharedProfileView && !isSharedProfileRoute && !isPublicProfileRoute) {
      exitSharedMode();
    }
  }, [location.pathname, isPublicProfileView, isSharedProfileView, exitPublicProfileMode, exitSharedMode]);
  
  return (
    <div className="App">
      {/* Shared Profile Banner - shown when viewing shared profile */}
      <SharedProfileBanner />
      
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/confirm" element={<AuthConfirm />} />
        <Route path="/auth/reset-password" element={<ResetPassword />} />
        <Route path="/options/start" element={<OptionsStart />} />
        <Route path="/share/:shareId" element={
          <>
            <SharedProfileGate />
            <ShareView />
          </>
        } />
        
        {/* ================================================================== */}
        {/* LEGACY SHARE ROUTES - share_id based (one-off share links)        */}
        {/* Now unified: uses real components via SharedProfileWrapper        */}
        {/* URL pattern: /shared/{shareId}/...                                */}
        {/* ================================================================== */}
        <Route path="/shared/:shareId/dashboard" element={
          <ProtectedRoute>
            <SharedProfileWrapper>
              <Dashboard />
            </SharedProfileWrapper>
          </ProtectedRoute>
        } />
        {/* Positions REMOVED from shared profile - redirect to Overview */}
        <Route path="/shared/:shareId/positions" element={
          <Navigate to="../dashboard" replace />
        } />
        <Route path="/shared/:shareId/history" element={
          <ProtectedRoute>
            <SharedProfileWrapper>
              <History />
            </SharedProfileWrapper>
          </ProtectedRoute>
        } />
        <Route path="/shared/:shareId/analytics" element={
          <ProtectedRoute>
            <SharedProfileWrapper>
              <Analytics />
            </SharedProfileWrapper>
          </ProtectedRoute>
        } />
        {/* Advanced and Performance routes in shared profile redirect to Analytics */}
        <Route path="/shared/:shareId/advanced" element={
          <Navigate to="../analytics" replace />
        } />
        <Route path="/shared/:shareId/performance" element={
          <Navigate to="../analytics" replace />
        } />
        <Route path="/shared/:shareId/alerts" element={
          <ProtectedRoute>
            <SharedProfileWrapper>
              <Alerts />
            </SharedProfileWrapper>
          </ProtectedRoute>
        } />
        <Route path="/shared/:shareId/about" element={
          <ProtectedRoute>
            <SharedProfileWrapper>
              <About />
            </SharedProfileWrapper>
          </ProtectedRoute>
        } />
        
        {/* ================================================================== */}
        {/* PUBLIC PROFILE ROUTES - Persistent, user_id based (NEW)           */}
        {/* These use the real components with PublicProfileWrapper           */}
        {/* URL pattern: /profile/{userId}/...                                */}
        {/* NOTE: These routes are NOT wrapped in ProtectedRoute because      */}
        {/* public profiles should be viewable without authentication.        */}
        {/* PublicProfileWrapper handles validation and redirects internally. */}
        {/* ================================================================== */}
        <Route path="/profile/:userId/dashboard" element={
          <PublicProfileWrapper>
            <Dashboard />
          </PublicProfileWrapper>
        } />
        {/* Positions REMOVED from public profile - redirect to Overview */}
        <Route path="/profile/:userId/positions" element={
          <Navigate to="../dashboard" replace />
        } />
        <Route path="/profile/:userId/history" element={
          <PublicProfileWrapper>
            <History />
          </PublicProfileWrapper>
        } />
        <Route path="/profile/:userId/analytics" element={
          <PublicProfileWrapper>
            <Analytics />
          </PublicProfileWrapper>
        } />
        {/* Advanced and Performance routes in public profile redirect to Analytics */}
        <Route path="/profile/:userId/advanced" element={
          <Navigate to="../analytics" replace />
        } />
        <Route path="/profile/:userId/performance" element={
          <Navigate to="../analytics" replace />
        } />
        <Route path="/profile/:userId/alerts" element={
          <PublicProfileWrapper>
            <Alerts />
          </PublicProfileWrapper>
        } />
        <Route path="/profile/:userId/about" element={
          <PublicProfileWrapper>
            <About />
          </PublicProfileWrapper>
        } />
        {/* Default public profile route redirects to dashboard */}
        <Route path="/profile/:userId" element={
          <PublicProfileWrapper>
            <Dashboard />
          </PublicProfileWrapper>
        } />
        
        {/* ================================================================== */}
        {/* VANITY URL ROUTES - Username-based shortcuts                       */}
        {/* URL pattern: /u/{username}                                         */}
        {/* Resolves username to userId, then redirects to /profile/{userId}   */}
        {/* ================================================================== */}
        <Route path="/u/:username" element={<VanityUrlResolver />} />
        
        {/* ================================================================== */}
        {/* SHARED OPEN POSITIONS - SEPARATE FROM PUBLIC PROFILE              */}
        {/* URL pattern: /positions/{username}                                 */}
        {/* Shows ONLY open positions in read-only mode                        */}
        {/* Does NOT require public_profile_enabled, only positions_sharing    */}
        {/* ================================================================== */}
        <Route path="/positions/:username" element={<SharedPositionsPage />} />
        
        {/* Dev-only admin bootstrap route */}
        <Route path="/dev-admin" element={<DevAdminBootstrap />} />
        
        {/* Public landing page (redirects to dashboard if authenticated) */}
        <Route path="/" element={<HomeRoute />} />
        
        {/* Protected routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <Dashboard />
            </>
          </ProtectedRoute>
        } />
        <Route path="/positions" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <OpenPositions />
            </>
          </ProtectedRoute>
        } />
        <Route path="/history" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <History />
            </>
          </ProtectedRoute>
        } />
        <Route path="/analytics" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <Analytics />
            </>
          </ProtectedRoute>
        } />
        <Route path="/analytics/setup/:setupId" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <SetupTrades />
            </>
          </ProtectedRoute>
        } />
        {/* Setup Group Detail Page */}
        <Route path="/analytics/setup-groups/:groupId" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <SetupGroupDetail />
            </>
          </ProtectedRoute>
        } />
        {/* Asset Group Detail Page */}
        <Route path="/analytics/asset-groups/:groupId" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <AssetGroupDetail />
            </>
          </ProtectedRoute>
        } />
        {/* Imported Analytics Page */}
        <Route path="/imported-analytics" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <ImportedAnalytics />
            </>
          </ProtectedRoute>
        } />
        {/* All Insights Page */}
        <Route path="/insights" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <AllInsights />
            </>
          </ProtectedRoute>
        } />
        {/* Planned Trades Detail Page */}
        <Route path="/advanced/planned-trades" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <PlannedTradesDetail />
            </>
          </ProtectedRoute>
        } />
        {/* Partial Execution Detail Page */}
        <Route path="/advanced/partial-execution" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <PartialExecutionDetail />
            </>
          </ProtectedRoute>
        } />
        {/* Risk Violations Detail Page */}
        <Route path="/advanced/risk-violations" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <RiskViolationsDetail />
            </>
          </ProtectedRoute>
        } />
        {/* Early Exits Detail Page */}
        <Route path="/advanced/early-exits" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <EarlyExitsDetail />
            </>
          </ProtectedRoute>
        } />
        {/* Hedge Trades Detail Page */}
        <Route path="/advanced/hedge-trades" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <HedgeTradesDetail />
            </>
          </ProtectedRoute>
        } />
        {/* Hand Size Trades Detail Page */}
        <Route path="/advanced/hand-size-trades" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <HandSizeTradesDetail />
            </>
          </ProtectedRoute>
        } />
        {/* Stop Adjustments Detail Page */}
        <Route path="/advanced/stop-adjustments-trades" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <StopAdjustmentsDetail />
            </>
          </ProtectedRoute>
        } />
        <Route path="/analytics/timeframe/:timeframe" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <TimeframeTrades />
            </>
          </ProtectedRoute>
        } />
        <Route path="/advanced" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <AdvancedAnalytics />
            </>
          </ProtectedRoute>
        } />
        <Route path="/performance" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <Performance />
            </>
          </ProtectedRoute>
        } />
        <Route path="/exchange-trades" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <ExchangeTrades mode="results" />
            </>
          </ProtectedRoute>
        } />
        <Route path="/exchange-trades/connect" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <ExchangeTrades mode="connections" />
            </>
          </ProtectedRoute>
        } />
        <Route path="/exchange-import" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <ImportExchangeData />
            </>
          </ProtectedRoute>
        } />
        <Route path="/holdings" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <Holdings />
            </>
          </ProtectedRoute>
        } />
        <Route path="/options" element={
          <OptionsRouteShell>
            <OptionsHome />
          </OptionsRouteShell>
        } />
        <Route path="/options/connect" element={
          <OptionsRouteShell>
            <DeribitConnect />
          </OptionsRouteShell>
        } />
        <Route path="/options/positions" element={
          <OptionsRouteShell>
            <OptionsPositions />
          </OptionsRouteShell>
        } />
        <Route path="/options/outlook" element={
          <OptionsRouteShell>
            <BtcOutlook />
          </OptionsRouteShell>
        } />
        <Route path="/options/gex" element={
          <OptionsRouteShell>
            <OptionsGex />
          </OptionsRouteShell>
        } />
        <Route path="/options/margin-volatility" element={
          <OptionsRouteShell>
            <MarginVolatility />
          </OptionsRouteShell>
        } />
        <Route path="/options/volatility" element={
          <OptionsRouteShell>
            <OptionsVolatility />
          </OptionsRouteShell>
        } />
        <Route path="/options/autopilot" element={
          <OptionsRouteShell>
            <OptionsAutopilot />
          </OptionsRouteShell>
        } />
        <Route path="/options/history" element={
          <OptionsRouteShell>
            <Operations />
          </OptionsRouteShell>
        } />
        <Route path="/options/operations" element={<Navigate to="/options/history" replace />} />
        <Route path="/options/analytics" element={
          <OptionsRouteShell>
            <OptionsAnalytics />
          </OptionsRouteShell>
        } />
        <Route path="/options/performance" element={
          <OptionsRouteShell>
            <OptionsPerformance />
          </OptionsRouteShell>
        } />
        <Route path="/options/holdings" element={
          <OptionsRouteShell>
            <OptionsHoldings />
          </OptionsRouteShell>
        } />
        <Route path="/options/alerts" element={
          <OptionsRouteShell>
            <OptionsAlerts />
          </OptionsRouteShell>
        } />
        <Route path="/options/about" element={
          <OptionsRouteShell>
            <OptionsAbout />
          </OptionsRouteShell>
        } />
        <Route path="/alerts" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <Alerts />
            </>
          </ProtectedRoute>
        } />
        <Route path="/about" element={<About />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/automated-trading-journal" element={<AutomatedTradingJournal />} />
        <Route path="/crypto-trading-journal" element={<CryptoTradingJournal />} />
        <Route path="/how-to-analyze-your-trades" element={<HowToAnalyzeYourTrades />} />
        <Route path="/manual-vs-automated-trading-journal" element={<ManualVsAutomatedJournal />} />
        <Route path="/why-traders-fail-to-improve" element={<WhyTradersFail />} />
        <Route path="/how-to-find-a-trading-setup" element={<HowToFindTradingSetup />} />
        <Route path="/improve-risk-reward-ratio" element={<ImproveRiskRewardRatio />} />
        <Route path="/how-many-trades-to-validate-a-strategy" element={<HowManyTradesToValidate />} />
        <Route path="/how-to-improve-day-trading" element={<HowToImproveDayTrading />} />
        <Route path="/profit-factor-trading" element={<ProfitFactorTrading />} />
        <Route path="/win-rate-trading" element={<WinRateTrading />} />
        <Route path="/overtrading-explained" element={<OvertradingExplained />} />
        <Route path="/why-consistency-is-hard-in-trading" element={<WhyConsistencyIsHard />} />
        <Route path="/what-is-geni" element={<WhatIsGeni />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/pt/diario-de-trades-automatico" element={<DiarioDeTradesAutomatico />} />
        <Route path="/pt/diario-de-trades-cripto" element={<DiarioDeTradesCripto />} />
        <Route path="/pt/como-analisar-trades" element={<ComoAnalisarTrades />} />
        <Route path="/pt/por-que-traders-nao-evoluem" element={<PorQueTradersNaoEvoluem />} />
        <Route path="/pt/por-que-consistencia-e-dificil-no-trading" element={<PorQueConsistenciaEDificil />} />
        <Route path="/pt/como-melhorar-risk-reward" element={<ComoMelhorarRiskReward />} />
        <Route path="/pt/profit-factor-trading" element={<ProfitFactorTradingPT />} />
        <Route path="/pt/win-rate-trading" element={<WinRateTradingPT />} />
        <Route path="/pt/quantos-trades-para-validar-estrategia" element={<QuantosTradesValidar />} />
        <Route path="/pt/como-encontrar-um-setup" element={<ComoEncontrarSetup />} />
        <Route path="/pt/diario-de-trades-manual-vs-automatico" element={<DiarioManualVsAutomatico />} />
        <Route path="/pt/como-melhorar-no-day-trade" element={<ComoMelhorarDayTrade />} />
        <Route path="/pt/overtrading" element={<OvertradingPT />} />
        <Route path="/pt/o-que-e-o-geni" element={<OQueEoGeni />} />
        <Route path="/support" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <Support />
            </>
          </ProtectedRoute>
        } />
        <Route path="/referral" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <Referral />
            </>
          </ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <Settings />
            </>
          </ProtectedRoute>
        } />
        <Route path="/billing" element={
          <ProtectedRoute>
            <>
              <Navigation />
              <Billing />
            </>
          </ProtectedRoute>
        } />
        <Route path="/admin" element={
          <AdminRoute>
            <>
              <Navigation />
              <Admin />
            </>
          </AdminRoute>
        } />
      </Routes>
      <TradesExchangeAnnouncementModal />
      <Toaster position="top-right" offset="80px" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LanguageProvider>
          <SharedProfileProvider>
            <AppContent />
          </SharedProfileProvider>
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;